export const FORM_STEP_MAPPING = {
  residential: 'residential_services availability',
  commercial: 'commercial_service: service availability',
  dumpster: 'dumpster: service availability',
};
export const FORM_STEP2_MAPPING = {
  residential: 'Residential:service details',
  commercial: 'Commercial:service details',
  dumpster: 'Dumpster:service details',
};

export const FORM_STEP3_MAPPING = {
  residential: 'residential:billing_information',
  commercial: 'commercial:billing_information',
  dumpster: 'dumpster : billing_information',
};

export const FORM_STEP4_MAPPING = {
  residential: 'Residential:order summary',
  commercial: 'Commercial:order summary',
  dumpster: 'Dumpster:order summary',
};

export const SERVICE_TYPE_MAPPING = {
  residential: 'residential services',
  commercial: 'commercial services',
  dumpster: 'dumpster rental services',
};

export type FormStepType = keyof typeof FORM_STEP_MAPPING;
